import { Box, Flex, Divider } from "@chakra-ui/react";
import { OrderDataFragment } from "data";
import { NotesList } from "features/notes/components/NotesList";
import { NoteComposer } from "features/notes/components/NoteComposer";

interface NotesForOrderProps {
  order: OrderDataFragment;
  showComposer: boolean;
}

export const NotesForOrder = (props: NotesForOrderProps) => {
  const { order, showComposer } = props;
  return (
    <Flex height="100%" direction="column">
      <Box flex="1">
        <NotesList filters={{ order: { id: { eq: order.id! } } }} />
      </Box>
      {showComposer ? (
        <Box py="4">
          <Divider mb={2} />
          <NoteComposer attachedTo={order} />
        </Box>
      ) : null}
    </Flex>
  );
};
